import { render, staticRenderFns } from "./zhinengguangaiDetails.vue?vue&type=template&id=0ed3d65a"
import script from "./zhinengguangaiDetails.vue?vue&type=script&lang=js"
export * from "./zhinengguangaiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports